<section class="table-row">
  <div class="customer-title row-item">
    <a class="db-link" [routerLink]="'./customer-view/'+customer?.id">{{customer?.id}}</a>
  </div>
  <div class="customer-title row-item long-text">
    {{customer?.name?.trim() || '-'}}
  </div>
  <div class="customer-email row-item long-text">
    {{customer?.email?.trim() || '-'}}
  </div>
  <div class="row-item">
    {{customer?.orders_count || 0}}
  </div>
  <div class="row-item">
    {{customer?.total_spend ? '$' + customer?.total_spend : '-'}}
  </div>
  <!--  <div class="customer-actions row-item">-->
  <!--    <a [dsTooltip]="dropdownList" class="dropdown" dsTooltipMode="click" dsTooltipPosition="bottom" dsTooltipAlign="right" dsTooltipSize="xs">-->
  <!--      <i class="db-icon db-icon-ds-more-l"></i>-->
  <!--    </a>-->
  <!--    <ng-template #dropdownList>-->
  <!--      <div class="db-dropdown-list">-->
  <!--        <div class="db-dropdown-list__content">-->
  <!--          <div>-->
  <!--            <ul>-->
  <!--              <li *ngFor="let item of dropdownOptions"><a class="db-dropdown-list__item {{item.className}}"-->
  <!--                                                          (click)="onRemoveItem()">-->
  <!--                <i class="db-icon db-icon-{{item.icon}}" *ngIf="item.icon"></i><span>{{item.label}}</span></a></li>-->
  <!--            </ul>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </ng-template>-->
  <!--  </div>-->
</section>
